module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modalMod",
    style: ({
      'z-index': _vm.modalModState ? _vm.zIndex : '-100',
      'opacity': _vm.modalModState ? (_vm.opacity ? _vm.opacity : '0') : '0'
    }),
    on: {
      "click": _vm.modalModFn
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a8eca42","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/modalMod/src/modalMod.vue
// module id = 525
// module chunks = 0